import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ItemSortProperty, ItemSortSpec } from '../item-sort-spec'
import { AsyncPipe } from '@angular/common'
import { ItemSortPropertyTableComponent } from '../item-sort-property-table/item-sort-property-table.component'

@Component({
  selector: 'app-item-sort-spec-detail',
  templateUrl: './item-sort-spec-detail.component.html',
  styleUrls: ['./item-sort-spec-detail.component.scss'],
  imports: [ItemSortPropertyTableComponent, AsyncPipe],
})
export class ItemSortSpecDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly itemSortSpec$ = new BehaviorSubject<ItemSortSpec>(null)

  @Output()
  public readonly itemSortSpecChange = new EventEmitter<ItemSortSpec>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get itemSortSpec(): ItemSortSpec {
    return this.itemSortSpec$.getValue()
  }

  @Input()
  public set itemSortSpec(spec: ItemSortSpec) {
    this.itemSortSpec$.next(spec)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onSortPropertiesChange(properties: ItemSortProperty[]) {
    this.itemSortSpec.properties = properties
    this.emitCurrentState()
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private emitCurrentState(): void {
    this.itemSortSpecChange.emit(this.itemSortSpec)
  }
}
